export class PurchaseOrderInfo {
  id: number;
  version: number;

  purchaseOrderNumber: string;
  revision: number;
  purchaseReqId: number;
  sentOn: string;
  pdfTemplateId?: number;
  vendorId: number;
}